import { TypeErrorDirective } from '@/core/generated-types';
import { ERROR_KINDS, TypeErrorKind } from '@/core/constants';

type TransformedErrorDirective = {
  heading: string;
  errors: string[];
};

export function findApplicableErrorDetails(
  errorDirectives: TypeErrorDirective[],
  kind?: TypeErrorKind,
) {
  const fallbackErrorDetails = {
    heading: 'Uh oh!',
    errors: ["We've encountered an unexpected error."],
  } as TransformedErrorDirective;

  if (!errorDirectives) {
    return fallbackErrorDetails;
  }

  const defaultErrorDirective = errorDirectives.find(
    (errorDirective) => errorDirective.fields.errorKind === ERROR_KINDS.DEFAULT,
  );

  const targetErrorDirective =
    kind &&
    errorDirectives.find((errorDirectives) => {
      return errorDirectives.fields.errorKind === kind;
    });

  const selectedErrorDirective = targetErrorDirective || defaultErrorDirective;

  if (!selectedErrorDirective) return fallbackErrorDetails;

  const { errorHeading, errorMessages } = selectedErrorDirective.fields;

  return {
    heading: errorHeading,
    errors: errorMessages?.map(
      (errorMessageEntry) => errorMessageEntry.fields.message,
    ),
  };
}
